import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IChatpracticeEvaluation } from "../../../Components/ChatbotPracticeEvaluation/IChatpracticeEvaluation";

export const ChatpracticeEvaluationSlicer = createSlice({
  name: "ChatpracticeEvaluationSlicer",
  initialState: {} as IReduxState<IChatpracticeEvaluation>,
  reducers: {
    ChatpracticeEvaluation: (state, _: PayloadAction<IChatpracticeEvaluation>) => {
      state.isLoading = true;
    },
    successChatpracticeEvaluation: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureChatpracticeEvaluation: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearChatpracticeEvaluationStatus: (state) => {
      state.data = {};
    },
  },
});

export const {
  ChatpracticeEvaluation,
  successChatpracticeEvaluation,
  failureChatpracticeEvaluation,
  clearChatpracticeEvaluationStatus,
} = ChatpracticeEvaluationSlicer.actions;

export default ChatpracticeEvaluationSlicer.reducer;
